import React from 'react';
import {
  Box,
  Container,
  VStack,
} from '@chakra-ui/react';
import RegistrationForm from '../components/RegistrationForm';

const RegisterView = ({ onRegisterSubmit }) => {

  return (
    <Container maxW="container.md" py={10}>
      <VStack spacing={8} align="center">
        <Box w="100%" maxW="400px">
          <RegistrationForm onSubmit={onRegisterSubmit} />
        </Box>
      </VStack>
    </Container>
  );
};

export default RegisterView;
